
const Wordbox = ({mainword,taboowords,ispending,error}) => {
    return ( 
        <div className="main-container">
            <div className="main-word">
               <h2>{mainword}</h2>
            </div>
           {
               !ispending && !error &&  <div className="taboo-words">
               {
                taboowords.map((word,index)=>(
                    <p key = {index}> {word} </p>
                ))
                
               }
            </div>
           }
           {
               ispending && <div className="loading">
                   <h2>Loading...</h2>
               </div>
           }
           {
              !ispending &&  error && <div className="error-message">
                   <h2>{error.message}</h2>
                </div>
           }
        </div>
    
    );
}
 
export default Wordbox;